import axios from 'axios';
import { getApiBaseUrl } from '../config/api';
import {
  LoginRequest,
  RegisterRequest,
  RegisterWithOrganizationRequest,
  AuthResponse,
  RefreshTokenRequest,
  SendVerificationCodeRequest,
  VerifyCodeRequest,
  VerifyCodeResponse,
  GoogleLoginRequest,
  GoogleRegisterWithOrganizationRequest
} from '../types/auth';

const API_BASE_URL = getApiBaseUrl();

export const authApi = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, credentials);
    return response.data;
  },

  register: async (userData: RegisterRequest): Promise<AuthResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/register`, userData);
    return response.data;
  },

  registerWithOrganization: async (userData: RegisterWithOrganizationRequest): Promise<AuthResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/register-organization`, userData);
    return response.data;
  },

  /**
   * Entrar con Google. Un 404 aquí NO es "endpoint inexistente": es el correo sin cuenta,
   * y trae el perfil de Google para precargar el registro (ver AuthErrorCodes).
   */
  googleLogin: async (request: GoogleLoginRequest): Promise<AuthResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/google/login`, request);
    return response.data;
  },

  googleRegisterWithOrganization: async (
    request: GoogleRegisterWithOrganizationRequest,
  ): Promise<AuthResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/google/register-organization`, request);
    return response.data;
  },

  refreshToken: async (request: RefreshTokenRequest): Promise<AuthResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/refresh`, request);
    return response.data;
  },

  logout: async (): Promise<void> => {
    // Backend marks POST /auth/logout with [Authorize], so we MUST send the
    // Bearer token; otherwise the call returns 401 and surfaces as
    // "Logout failed" on the next render of LoginForm. The slice still treats
    // this call as best-effort — see authSlice.ts logout thunk.
    const token = localStorage.getItem('accessToken');
    await axios.post(
      `${API_BASE_URL}/auth/logout`,
      null,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
    );
  },

  sendVerificationCode: async (request: SendVerificationCodeRequest): Promise<{ message: string }> => {
    const response = await axios.post(`${API_BASE_URL}/auth/send-verification-code`, request);
    return response.data;
  },

  verifyCode: async (request: VerifyCodeRequest): Promise<VerifyCodeResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/verify-code`, request);
    return response.data;
  },
};
